import type { CSSProperties, PropsWithChildren, ReactElement } from "react";

import type { Styles } from "react-modal";

import { BasicModal, IconButton } from "@similarweb/ui-components";

import { StyledCloseIconWrapper } from "./styles";

export interface CustomBasicModalProps {
    isOpen: boolean;
    shouldCloseOnOverlayClick?: boolean;
    onClose?: () => void;
    customStyles?: Styles;
    closeIconStyles?: CSSProperties;
    withCloseIcon?: boolean;
}

const CustomBasicModal = ({
    isOpen,
    shouldCloseOnOverlayClick = true,
    onClose,
    customStyles,
    closeIconStyles,
    children,
    withCloseIcon = true,
}: PropsWithChildren<CustomBasicModalProps>): ReactElement => {
    return (
        <BasicModal
            isOpen={isOpen}
            onRequestClose={onClose}
            customStyles={customStyles}
            closeIconConfig={{ show: false }}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            {children}

            {withCloseIcon ? (
                <StyledCloseIconWrapper style={closeIconStyles}>
                    <IconButton
                        type="flat"
                        iconSize="sm"
                        iconName="clear"
                        onClick={onClose}
                    />
                </StyledCloseIconWrapper>
            ) : null}
        </BasicModal>
    );
};

export default CustomBasicModal;
